import LocalizedStrings from 'localized-strings';

/**
 * @todo Validate locales
 * @see https://linear.app/shine/issue/CAC-1053
 */
const locales = new LocalizedStrings({
  en: {
    callout:
      'Vous pouvez choisir d’envoyer votre export à plusieurs destinataires (à votre comptable, vos associé·es ou votre équipe)',
    inputHint:
      'Séparez les e-mails par un point-virgule “;” pour l’envoi à plusieurs destinataires.',
    inputLabel: 'E-mail(s)',
    title: 'Envoyer à',
  },
  fr: {
    callout:
      'Vous pouvez choisir d’envoyer votre export à plusieurs destinataires (à votre comptable, vos associé·es ou votre équipe)',
    inputHint:
      'Séparez les e-mails par un point-virgule “;” pour l’envoi à plusieurs destinataires.',
    inputLabel: 'E-mail(s)',
    title: 'Envoyer à',
  },
} as const);

export default locales;
